import { useQuery } from '@apollo/client'
import {
  BookkeepersManagementTaskTypesDocument,
  BookkeepersManagementTaskTypesQuery,
} from 'generated/resources/graphql'

import legalEntities from 'modules/core/store/collections/legalEntities'

import useIncidenceTypeQueryParam from 'modules/bookkeepers/hooks/useIncidenceTypeQueryParam'
import { useBookkeeperView } from 'modules/bookkeepers/lib/bookkeeperViewContext'
import { getIncidenceTypeNavigationMapping } from 'modules/bookkeepers/lib/incidenceTypeNavigation'

import useGetBookkeeperCompanies from './useGetBookkeeperCompanies'

export type IncidenceTaskTypesQueryData =
  BookkeepersManagementTaskTypesQuery['bookkeepersManagement']['taskTypes'][number]

const useGetIncidenceTaskTypes = () => {
  const { incidenceType } = useIncidenceTypeQueryParam()
  const mapping = getIncidenceTypeNavigationMapping()
  const filterTypeValuesFromParams = mapping[incidenceType]?.join(',')

  const isBookkeeperView = useBookkeeperView()
  const { loading: loadingBookkeeperCompanies, bookkeeperCompanies } = useGetBookkeeperCompanies()
  const bookkeeperCompanyId = bookkeeperCompanies?.[0]?.companyId
  const firstCompanyId = +legalEntities.models[0]?.get('company_id')
  const referenceCompanyIds = bookkeeperCompanyId ? [bookkeeperCompanyId] : [firstCompanyId]

  const { loading, data } = useQuery(BookkeepersManagementTaskTypesDocument, {
    variables: {
      companyIds: referenceCompanyIds,
      hidden: false,
    },
    context: {
      isBookkeeperView,
    },
    skip: !referenceCompanyIds?.length || !filterTypeValuesFromParams || loadingBookkeeperCompanies,
  })

  const taskTypes = data?.bookkeepersManagement?.taskTypes.filter(
    (taskType) => taskType.incidenceName === filterTypeValuesFromParams
  )

  return {
    loading,
    taskTypes: taskTypes || [],
  }
}

export default useGetIncidenceTaskTypes
